export default __webpack_public_path__ + "assets/models/c2164951fe1bb459188ba718215c8482.glb";